<style>
  #main {
    height: 100%;
  }
  .left-menu {
    position: fixed;
    height: 100%;
    height: calc(100% - 60px);
    overflow-x: hidden;
    overflow-y: auto;
    background: #fff;
  }
  .layout-content-main {
    padding-top: 24px;
    padding-bottom: 24px;
    margin-left: 210px;
    position: relative;
    /* height: calc(100% - 60px); */
    height: 100%;
    overflow-y: auto;
    /* background: #fff; */
  /*  overflow-x: hidden;
    overflow-y: auto;*/
    background: #f4f4f5;
  }
  .layout-inner-content {
    min-height: 100%;
    margin: 0px 24px 24px 24px;
    background: #fff;
    padding: 24px;
    border-radius: 8px;
  /*  overflow-x: hidden;
    overflow-y: auto;*/
  }
</style>
<template>
  <div id="main">
    <div class="left-menu">
      <LeftMenu></LeftMenu>
    </div>
    <div class="layout-content-main">

      <div class="layout-inner-content">
        <router-view></router-view>
      </div>
    </div>
    <KbAssistant></KbAssistant>
  </div>
    <!-- <Row>
      <i-col span="5">
        <LeftMenu></LeftMenu>
      </i-col>
      <i-col span="19">
        <div class="layout-content-main">
          <router-view></router-view>
        </div>
      </i-col>
    </Row> -->
</template>
<script>
  import LeftMenu from './LeftMenu.vue'
  import KbAssistant from '@/components/kb/KbAssistant.vue'

  export default {
    components: {
      LeftMenu,
      KbAssistant,
    },
    data () {
      return {}
    },
    methods: {},
    created () {
    }
  }
</script>



// WEBPACK FOOTER //
// CommonMain.vue?0c122e9f